import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseUploadIcon = ({ className }: IProps) => (
    <svg
        className={className}
        fill="none"
        height="15"
        viewBox="0 0 56 56"
        width="15"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M0 50.4004H56V56.0004H0V50.4004Z" fill="#333333" />
        <path d="M0 56.0003V35.8403H5.6V56.0003H0Z" fill="#333333" />
        <path
            d="M50.4004 56.0003V35.8403H56.0004V56.0003H50.4004Z"
            fill="#333333"
        />
        <path
            d="M30.7776 9.56571V42C30.7776 43.5486 29.5204 44.8 27.9776 44.8C26.429 44.8 25.1776 43.5429 25.1776 42V9.56571L14.8576 19.8857C13.7661 20.9771 11.9947 20.9714 10.9033 19.88C9.81184 18.7886 9.81184 17.0114 10.8976 15.9257L25.8976 0.925714C26.4118 0.354286 27.1547 0 27.9776 0C28.8061 0 29.5547 0.365714 30.069 0.937143L45.0576 15.9257C46.149 17.0171 46.149 18.7886 45.0518 19.88C43.9604 20.9714 42.189 20.9771 41.0976 19.8857L30.7776 9.56571Z"
            fill="#333333"
        />
    </svg>
);

export const UploadIcon = styled(BaseUploadIcon)``;
